import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingAccountDetail } from './types';

export function useBillingAccount(accountId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingAccountDetail>(
    accountId ? `commenda-billing/mirror/accounts/${accountId}` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { account: data ?? null, error, isLoading, mutate };
}
